<div class="container-fluid contenedor">
    <p class="title">404</p>
    <p class="sub-title">{{ messageKey | translate }}</p>
</div>
  